import React from 'react'
import styles from '../../../styles/components/qcagentapprovevideofeature.module.scss'
import playButtonIcon from "../../../public/assets/images/playButtonIcon.svg"
// import pauseButtonIcon from "../../public/assets/images/pauseButtonIcon.png"
import { Box, Button, List, ListItem, Slider } from '@mui/material'
import VideoNextIcon from '../../../public/assets/icons/VideoNextIcon'
import VideoVolumeIcon from '../../../public/assets/icons/VideoVolumeIcon'
import VideoSettingsIcon from '../../../public/assets/icons/VideoSettingsIcon'
import VideoScreenIcon from '../../../public/assets/icons/VideoScreenIcon'

export const QcAgentApprovedVideoFeatured = () => {
  return (
    <Box className={`${styles.videoEditor}`}>
    <List disablePadding>
        <ListItem>
            <Button className={styles.playPauseBtn}><img src={playButtonIcon} width={35} height={35} alt='' /></Button>
            {/* <Button className={styles.playPauseBtn}><img src={pauseButtonIcon} width={35} height={35} alt='' /></Button> */}
        </ListItem>
        <ListItem>
            <Box className={styles.videoRangeWrap}>
                <p>0:51</p>
                <Box width={298} className={styles.videoRange}>
                    <Slider defaultValue={31} aria-label="Default" valueLabelDisplay="auto" />
                </Box>
                <p className={styles.endtime}>2:31</p>
            </Box>
        </ListItem>
        <ListItem className={styles.vdoNxt}><Button><VideoNextIcon /></Button></ListItem>
        <ListItem className={styles.btnPos}><Button><VideoVolumeIcon /></Button></ListItem>
        <ListItem className={styles.btnPos}><Button><VideoSettingsIcon /></Button></ListItem>
        <ListItem className={styles.btnPos}><Button><VideoScreenIcon /></Button></ListItem>
    </List>
</Box>
  )
}
